<template>
  <div class="wrapper">
    <Main />
    <div class="main main-raised">
      <Haus />
      <Greetsiel />
      <Galerie />
      <Lage />
      <Kontakt />
    </div>
  </div>
</template>

<script>
import Main from "./deBontje/Main";
import Greetsiel from "./deBontje/Greetsiel";
import Haus from "./deBontje/Haus";
import Galerie from "./deBontje/Galerie";
import Lage from "./deBontje/Lage";
import Kontakt from "./deBontje/Kontakt";

export default {
  components: {
    Main,
    Greetsiel,
    Galerie,
    Haus,
    Kontakt,
    Lage
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
</style>
